module.exports = __webpack_public_path__ + "static/assets/f664a861172b4522e755f80fd4f5cb89.png";